export const environment = {
  production: false,
  apiUrl: 'https://zatapi.viuzat.com/api/',
};
